import { _log } from '@/lib/utils'
import type { Chain, WalletClient } from 'viem'
import type { UseWalletClientReturnType } from 'wagmi'

const enableChain = async (chain: Chain, walletClient: UseWalletClientReturnType) => {
  const setChain = async () => await walletClient?.data?.switchChain({ id: chain.id })

  try {
    await setChain()
  } catch (error) {
    _log('Chain not added, adding chain…')

    await walletClient?.data?.addChain({ chain })
    await setChain()
  }
}

export { enableChain }
